export const initializeDeferredCss = () => {
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll<HTMLLinkElement>('link[rel="preload"]').forEach(link => {
      if (link.href.includes(".css")) {
        link.rel = "stylesheet";
        link.removeAttribute("as");
      }
    });
  });
};
